<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>The Elephant to Hollywood</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="9780805093902.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/9780805093902_fm01#fm01">Prologue</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/9780805093902_ch01#ch01">One: The Twilight Zone</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/9780805093902_ch02#ch02">Two: The Elephant</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/9780805093902_ch03#ch03">Three: Learning the Ropes</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch04#ch04" title="Link target outside of Sample">Four: Everyone Gets Lucky Sometimes….</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch05#ch05" title="Link target outside of Sample">Five: Hello, Alfie</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch06#ch06" title="Link target outside of Sample">Six: To Hollywood</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch07#ch07" title="Link target outside of Sample">Seven: No Holly, No Woods</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch08#ch08" title="Link target outside of Sample">Eight: The Fast Lane</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ph01#ph01" title="Link target outside of Sample">Photo Insert I</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch09#ch09" title="Link target outside of Sample">Nine: Falling in Love</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch10#ch10" title="Link target outside of Sample">Ten: The Best of the Best</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch11#ch11" title="Link target outside of Sample">Eleven: An Englishman in LA</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch12#ch12" title="Link target outside of Sample">Twelve: Oscar Nights</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch13#ch13" title="Link target outside of Sample">Thirteen: Family Secrets</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch14#ch14" title="Link target outside of Sample">Fourteen: Kitchen Sink Dramas</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch15#ch15" title="Link target outside of Sample">Fifteen: Highs and Lows in Miami Beach</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch16#ch16" title="Link target outside of Sample">Sixteen: Back in the Game</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ph02#ph02" title="Link target outside of Sample">Photo Insert II</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch17#ch17" title="Link target outside of Sample">Seventeen: Home</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch18#ch18" title="Link target outside of Sample">Eighteen: The Mayfair Orphans</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch19#ch19" title="Link target outside of Sample">Nineteen: A Date at the Palace</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch20#ch20" title="Link target outside of Sample">Twenty: The Quiet American</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch21#ch21" title="Link target outside of Sample">Twenty-One: Batman Begins</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch22#ch22" title="Link target outside of Sample">Twenty-Two: Back to the Elephant</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780805093902_ch23#ch23" title="Link target outside of Sample">Twenty-Three: What It’s Really All About</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780805093902_bm01#bm01" title="Link target outside of Sample">Epilogue</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780805093902_bm02#bm02" title="Link target outside of Sample">My Top Ten Favorite Movies of All Time</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780805093902_bm03#bm03" title="Link target outside of Sample">My Own Favorite Movies</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780805093902_ind01#ind01" title="Link target outside of Sample">Index</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780805093902_ack01#ack01" title="Link target outside of Sample">Acknowledgments</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780805093902_con01.vue?04f090d8